import { MetaInfoViewStatus } from 'streams/views/mainContent/types';
import { ViewStatusRecord } from './types';
import { type I18nLocale, t } from '@ardoq/i18n';

const viewStatusLabels: ViewStatusRecord<string> = {
  [MetaInfoViewStatus.BETA]: 'Beta',
  [MetaInfoViewStatus.SOON_TO_BE_DISCONTINUED]: 'Soon to be discontinued',
  [MetaInfoViewStatus.DISCONTINUED]: 'Discontinued',
  [MetaInfoViewStatus.NEW]: 'New',
};

export const getViewStatusLabel = (
  i18nLocale: I18nLocale,
  viewStatus: keyof typeof viewStatusLabels
): string => {
  switch (viewStatus) {
    case MetaInfoViewStatus.BETA:
      return t(i18nLocale, 'views:viewStatus.beta', 'Beta');
    case MetaInfoViewStatus.SOON_TO_BE_DISCONTINUED:
      return t(
        i18nLocale,
        'views:viewStatus.soonToBeDiscontinued',
        'Soon to be discontinued'
      );
    case MetaInfoViewStatus.DISCONTINUED:
      return t(i18nLocale, 'views:viewStatus.discontinued', 'Discontinued');
    case MetaInfoViewStatus.NEW:
      return t(i18nLocale, 'views:viewStatus.new', 'New');
    default:
      // Exhaustiveness check — adding a new ExistentMetaInfoViewStatus must update the switch.
      viewStatus satisfies never;
      return viewStatusLabels[viewStatus];
  }
};

export { viewStatusLabels };
